import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import styles from './styles'

const ProgressBar = props => (
  <div>
    {props.progress >= 0 && (
      <div className={styles.container}>
        <div className={cx(styles.track, styles.progress(props.progress))} />
      </div>
    )}
  </div>
)

ProgressBar.propTypes = {
  progress: PropTypes.number,
}

export default ProgressBar
